// Admin
  export const ADMIN_USERROLE_ACTIONS = {
    // list
    USERROLE_LIST_REQUEST: "ADMIN_USERROLE_LIST_REQUEST",
    USERROLE_LIST_RESPONSE: "ADMIN_USERROLE_LIST_RESPONSE",
    USERROLE_LIST_ERROR: "ADMIN_USERROLE_LIST_ERROR",

    // create
    USERROLE_CREATE_REQUEST: "USERROLE_REQUEST",
    USERROLE_CREATE_RESPONSE: "USERROLE_RESPONSE",
    USERROLE_CREATE_ERROR: "USERROLE_ERROR",

    // update
    USERROLE_EDIT_REQUEST: "USERROLE_EDIT_REQUEST",
    USERROLE_EDIT_RESPONSE: "USERROLE_EDIT_RESPONSE",
    USERROLE_EDIT_ERROR: "USERROLE_EDIT_ERROR",

    // delete
    USERROLE_DELETE_REQUEST: "USERROLE_DELETE_REQUEST",
    USERROLE_DELETE_RESPONSE: "USERROLE_DELETE_RESPONSE",
    USERROLE_DELETE_ERROR: "USERROLE_DELETE_ERROR",
  };
  